
export const text = `

That's-- that's a little bit too comfortable! Hey! Wake up! Argh. No, that's fine. I'll stay down here. Good night, Devy.

[SEVERAL MOMENTS PASS. AFTER THE TEN MINUTE MARK, THE MICROPHONE IS FISHED OUT OF WHERE IT HAD NESTLED ITSELF.]

Oh. Hm. That was all recorded, huh? Hm. Well. This is… this is Researcher Ria, reporting that what you have heard shows… no new occurrences. Nothing else to report. 

Ending log.

`